export default {
  modifierSelectionPriceColor: Styles.color.grey.two,
  quantityDetailPadding: '0.4rem 0 0',
  quantityDetailMargin: '0.6rem 0 0',
};
